// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49168196","453":"b049e884","667":"49bd1fd3","977":"6ee40280"}[chunkId] + ".chunk.js";
};